export const bizNumberPipe = (
  value: string | undefined,
  option?: string
): string => {
  // 10자리면 사업자번호, 13자리면 주민등록번호
  if (!value) {
    if (option === "no-default-dash") return "";
    else return "-";
  } else if (value.length == 10) {
    return value.toString().replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
  } else if (value.length == 13) {
    return value
      .toString()
      .replace(/(\d{6})(\d{7})/, "$1-$2")
      .replace(/(?<=.{8})./gi, "*");
  } else {
    return value.toString();
  }
};
